import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.12_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@playwright+test@1.58.2_react-dom@19_e5g3edd77pwoa6hnpgepczfc7e/node_modules/next/dist/client/script.js");
